import { render, staticRenderFns } from "./SchaDonorTabListComp.vue?vue&type=template&id=c6d6e9a2&scoped=true"
import script from "./SchaDonorTabListComp.vue?vue&type=script&lang=js"
export * from "./SchaDonorTabListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d6e9a2",
  null
  
)

export default component.exports